"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var slider_1 = require("@material/slider");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Stateful_1 = require("./Stateful");

var InputSlider =
/** @class */
function (_super) {
  __extends(InputSlider, _super);

  function InputSlider(props) {
    var _this = _super.call(this, props) || this;

    _this.openLsgDrawerEventListener = function () {
      return _this.mdcSlider.layout();
    };

    _this.uuid = props.id || uniqid_1["default"]("lsg--inputslider-");
    return _this;
  }

  InputSlider.prototype.componentDidMount = function () {
    var _this = this;

    window.addEventListener("openLsgDrawerEvent", this.openLsgDrawerEventListener);

    if (this.elementRef) {
      this.mdcSlider = new slider_1.MDCSlider(this.elementRef);
      this.mdcSlider.listen("MDCSlider:change", function () {
        if (_this.mdcSlider.value !== _this.props.value) {
          _this.props.onChange(_this.mdcSlider.value, _this.uuid);

          _this.mdcSlider.value = _this.props.value;
        }
      });
    }
  };

  InputSlider.prototype.componentDidUpdate = function () {
    var isActive = this.mdcSlider.foundation_.active_;

    if (!isActive) {
      // only change if not dragging
      this.mdcSlider.value = this.props.value;

      if (this.props.maxValue < this.mdcSlider.min) {
        this.mdcSlider.min = this.props.minValue;
        this.mdcSlider.max = this.props.maxValue;
      } else {
        this.mdcSlider.max = this.props.maxValue;
        this.mdcSlider.min = this.props.minValue;
      }
    }

    this.mdcSlider.step = this.props.step;
    this.mdcSlider.disabled = this.props.disabled;
  };

  InputSlider.prototype.componentWillUnmount = function () {
    window.removeEventListener("openLsgDrawerEvent", this.openLsgDrawerEventListener);
    this.mdcSlider.destroy();
  };

  InputSlider.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        label = _a.label,
        value = _a.value,
        minValue = _a.minValue,
        maxValue = _a.maxValue,
        step = _a.step,
        disabled = _a.disabled,
        helperMinValue = _a.helperMinValue,
        helperMaxValue = _a.helperMaxValue,
        onBlur = _a.onBlur,
        onFocus = _a.onFocus;
    return React.createElement("div", {
      id: this.uuid,
      className: CSSPrefix_1.lsgPre + "inputslider"
    }, label && React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputslider-label"
    }, label), React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames(["mdc-slider", step && "mdc-slider--discrete", step && "mdc-slider--display-markers", disabled && CSSPrefix_1.lsgPre + "inputslider__disabled", className]),
      tabIndex: 0,
      role: "slider",
      "aria-disabled": disabled,
      "aria-valuemin": minValue,
      "aria-valuemax": maxValue,
      "aria-valuenow": value,
      "aria-label": label,
      "data-step": step,
      ref: function ref(el) {
        return _this.elementRef = el;
      },
      onBlur: onBlur,
      onFocus: onFocus
    }, React.createElement("div", {
      className: "mdc-slider__track-container"
    }, React.createElement("div", {
      className: "mdc-slider__track"
    }), React.createElement("div", {
      className: "mdc-slider__track-marker-container"
    })), React.createElement("div", {
      className: "mdc-slider__thumb-container"
    }, React.createElement("div", {
      className: "mdc-slider__pin"
    }, React.createElement("span", {
      className: "mdc-slider__pin-value-marker"
    })), React.createElement("svg", {
      className: "mdc-slider__thumb",
      viewBox: "0 0 21 21"
    }, React.createElement("circle", {
      cx: "10.5",
      cy: "10.5",
      r: "8.725"
    })))), (helperMinValue || helperMaxValue) && React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputslider-helper"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputslider-helper-min"
    }, helperMinValue), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputslider-helper-max"
    }, helperMaxValue)));
  };

  InputSlider.Stateful = Stateful_1.Stateful;
  InputSlider.defaultProps = {
    onBlur: function onBlur() {
      /* empty */
    },
    onFocus: function onFocus() {
      /* empty */
    },
    onChange: function onChange() {
      /* empty */
    },
    minValue: 0
  };
  return InputSlider;
}(React.Component);

exports.InputSlider = InputSlider;